<script lang="ts">
	import type { BoutInDepthStats } from '../types';

	export let stats: BoutInDepthStats;
	export let corner: 'red' | 'blue';

	const statGroups = {
		'Punches Thrown': stats.punchesThrown,
		'Punches Landed': stats.punchesLanded,
		'Punches Missed': stats.punchesMissed
	};
</script>

<div class="column" class:spacer={corner === 'blue'}>
	<h4 class="{corner} text-center py-2 mb-0">In-Depth</h4>
	<table class="py-4 text-center">
		<thead>
			<tr>
				<td class="py-3"><strong>Head</strong></td>
				<td class="py-3"><strong>Body</strong></td>
				<td colspan="2" class="py-3"><strong>Total</strong></td>
			</tr>
		</thead>
		<tbody>
			{#each Object.entries(statGroups) as [title, statGroup]}
				<tr class="d-sm-none text-start ps-2 mobile-caption">
					<td colspan="3">{title}</td>
				</tr>

				<tr class="group-header">
					<td>{statGroup.total.head}</td>
					<td>{statGroup.total.body}</td>
					<td colspan="2">{statGroup.total.total}</td>
				</tr>

				<tr class="d-sm-none text-start ps-2 mobile-caption">
					<td colspan="3" class="pt-3">From distance</td>
				</tr>
				<tr>
					<td class="pt-sm-3">{statGroup.distance.head}</td>
					<td class="pt-sm-3">{statGroup.distance.body}</td>
					<td class="pt-sm-3" colspan="2">{statGroup.distance.total}</td>
				</tr>

				<tr class="d-sm-none text-start ps-2 mobile-caption">
					<td colspan="3">From clinch</td>
				</tr>
				<tr>
					<td class="pb-3">{statGroup.clinch.head}</td>
					<td class="pb-3">{statGroup.clinch.body}</td>
					<td class="pb-3" colspan="2">{statGroup.clinch.total}</td>
				</tr>
			{/each}
		</tbody>
	</table>
</div>

<style>
	.column {
		width: 37%;
	}

	table {
		background-color: white;
		width: 100%;
	}

	td {
		padding-right: 10px;
		padding-left: 10px;
	}

	.spacer {
		margin-right: 5%;
	}
	.blue {
		color: white;
		background-color: blue;
	}

	.red {
		background-color: red;
		color: white;
	}

	.group-header {
		background-color: lightgray;
	}

	td {
		padding-right: 10px;
		padding-left: 10px;
	}

	@media (max-width: 576px) {
		.spacer {
			margin-right: 10px;
		}
		.column,
		.column {
			width: 50%;
		}

		td {
			padding-right: 0;
			padding-left: 0;
			font-size: 14px;
		}

		tr.mobile-caption td {
			font-size: 10px;
		}
	}
</style>
